import { Strings } from "@app/constants";

export const editProfilesFields = [
  [
    {
      name: "firstName",
      label: Strings.auth.firstName,
      placeholder: "First Name",
      type: "text",
    },
    {
      name: "lastName",
      label: Strings.auth.lastName,
      placeholder: "Last Name",
      type: "text",
    },
  ],
  [
    {
      name: "phone",
      label: Strings.myProfile.mobileNumber,
      placeholder: "Mobile Number",
      type: "text",
    },
    {
      name: "email",
      label: Strings.auth.email,
      placeholder: "store@gmail.com",
      type: "email",
    },
  ],
];